import React, { memo } from 'react';
import { motion } from 'framer-motion';
export const CreditsSection = () => {
  return <section className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-733">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black opacity-20" data-id="element-734"></div>
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-735">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-736">
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-737"></div>
          <h2 className="font-serif text-4xl md:text-5xl text-amber-400 tracking-wider uppercase" data-id="element-738">
            Credits
          </h2>
        </motion.div>
        {/* Presented By */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20" data-id="element-739">
          <div className="border border-amber-400/30 p-8 bg-black/40 text-center" data-id="element-740">
            <h3 className="text-amber-400 font-light text-sm tracking-[0.3em] uppercase mb-4" data-id="element-741">
              Proudly Presented By
            </h3>
            <div className="w-16 h-px bg-amber-400/30 mx-auto mb-6" data-id="element-742"></div>
            <p className="text-white text-lg font-light tracking-wider" data-id="element-743">
              Akal Steel (2005) Inc.
            </p>
          </div>
        </motion.div>
        {/* In Memory */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-24" data-id="element-744">
          <div className="border-2 border-amber-400/30 p-12 bg-black/60 text-center" data-id="element-745">
            <h3 className="font-serif text-3xl text-amber-400 mb-8 tracking-wider uppercase" data-id="element-746">
              In Memory
            </h3>
            <div className="w-20 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-747"></div>
            <p className="text-white text-sm mb-6 tracking-wider uppercase font-light" data-id="element-748">
              With Gratitude to Sardar Surinder Kundan Singh
            </p>
            <p className="text-white/70 text-xs mb-6 tracking-wider uppercase font-light leading-relaxed" data-id="element-749">
              Founding Chairman, Scarborough Gurdwara • Original Sevadar, Art of
              the Sikh Kingdoms (1947-2012)
            </p>
            <p className="text-white/50 text-xs tracking-wider uppercase font-light" data-id="element-750">
              This work—from the anonymous creator of Sikhiwiki & Turbanizer—is
              created in his memory
            </p>
          </div>
        </motion.div>
        {/* Credits Grid */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-751">
          {/* Executive Producers */}
          <div data-id="element-752">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-753">
              Executive Producers
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-754">
              Jasvinder Singh
              <br data-id="element-755" />
              Baljeet Kaur
              <br data-id="element-756" />
              Harsimran Kaur (M/O Akaash Singh & Baani Kaur)
              <br data-id="element-757" />
              Aiksimar Singh
              <br data-id="element-758" />
              JJ Singh Brar
            </p>
          </div>
          {/* Creative Direction */}
          <div data-id="element-759">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-760">
              Creative Direction
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-761">
              Kanwar Singh Dhillon
              <br data-id="element-762" />
              Inkquisitive
            </p>
          </div>
          {/* Sound Engineering */}
          <div data-id="element-763">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-764">
              Sound Engineering
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-765">
              J-Statik
            </p>
          </div>
          {/* Historical Consultants */}
          <div data-id="element-766">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-767">
              Historical Consultants
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-768">
              Sarbpreet Singh
              <br data-id="element-769" />
              Prableen Kamboj
            </p>
          </div>
          {/* Immersive Technology */}
          <div data-id="element-770">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-771">
              Immersive Technology
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-772">
              Secret Location
              <br data-id="element-773" />
              ATHINK AI Studio
            </p>
          </div>
          {/* Culinary Direction */}
          <div data-id="element-774">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-775">
              Culinary Direction
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-776">
              Gagan Grewal-Sagoo
              <br data-id="element-777" />
              Baani Kundan Kaur
            </p>
          </div>
          {/* Partners */}
          <div data-id="element-778">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-779">
              Partners
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-780">
              Ethnicity Matters (Media Partner)
              <br data-id="element-781" />
              Sikhiwiki
            </p>
          </div>
          {/* Supported By */}
          <div className="md:col-span-2 lg:col-span-3" data-id="element-782">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-783">
              Supported By
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light mb-6" data-id="element-784">
              Akal Steel (2005) Inc.
              <br data-id="element-785" />
              Sikh Heritage Museum of Canada
              <br data-id="element-786" />
              Sikh Foundation of Canada
            </p>
            <p className="text-amber-400 font-light text-xs tracking-[0.3em] uppercase mb-3" data-id="element-787">
              Contributing Sikh University Alumni
            </p>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-788">
              IIT Delhi (Delhi, India)
              <br data-id="element-789" />
              Ivey Business School (London, Canada)
              <br data-id="element-790" />
              INSEAD (Fontainebleau, France • Singapore)
              <br data-id="element-791" />
              University of Toronto (Toronto, Canada)
              <br data-id="element-792" />
              University of Waterloo (Waterloo, Canada)
            </p>
          </div>
          {/* Special Thanks */}
          <div className="md:col-span-2 lg:col-span-3" data-id="element-793">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-794">
              Special Thanks
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-795">
              AKAash Kundan Singh • Baani Kundan Kaur • Amardeep Singh • Jeevan
              Singh • Himmat Singh • Harman Kaur • Bibek Singh • Amandeep
              Dhaliwal • Suresh Singh Bhalla • Sabi Marwah • Lally Marwah • Gary
              Singh • Sat Gosal • Thakral Family (Singapore) • Sidhu Family
              (Singapore) • Sahni Family (Dubai) • Calais Family (Sydney) • Alg
              Family (London) • Mattharu Family (San Francisco) • Butter Chicken
              Cartel (Cancun)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};